import React from 'react';
import Slider1 from '../../Assets/s1.jpg';
import Slider2 from '../../Assets/s2.jpg';
import Slider3 from '../../Assets/s3.jpg';
import Slider4 from '../../Assets/s4.jpg';
import Slider5 from '../../Assets/s5.jpg';
import './Slider.css';

const Carousel = () => {
  return (
    <div id="carouselExampleFade" className="carousel slide carousel-fade" data-bs-ride="carousel">
      <div className="carousel-inner">
        <div className="carousel-item active">
          <img src={Slider1} className="d-block w-100" alt="..." />
        </div>
        <div className="carousel-item">
          <img src={Slider2} className="d-block w-100" alt="..." />
        </div>
        <div className="carousel-item">
          <img src={Slider3} className="d-block w-100" alt="..." />
        </div>
        <div className="carousel-item">
          <img src={Slider4} className="d-block w-100" alt="..." />
        </div>
        <div className="carousel-item">
          <img src={Slider5} className="d-block w-100" alt="..." />
        </div>
      </div>
      <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleFade" data-bs-slide="prev">
        <span className="carousel-control-prev-icon s-bg-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Previous</span>
      </button>
      <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleFade" data-bs-slide="next">
        <span className="carousel-control-next-icon s-bg-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Next</span>
      </button>
    </div>
  );
};

export default Carousel;
